import React, { useMemo } from 'react'
import { useApiFormNodeMove, useApiFormNodeTemplate, useApiListNodeTemplate, useApiListNodeTemplateCategory } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconMove } from '../../../../../../shared/icon/icon'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { TemplateMenu } from '../../common/menu/node-actions'
import { buildTemplatePath } from '../../common/shared/build-path'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleCategorySelectFilter } from '../../../../../../shared/form-simple/form-category-select-filter'

export const NodeTemplateMove = ({ parentURL, nodeID }) => {
  const history = useHistory()

  const apiFormNodeTemplate = useApiFormNodeTemplate()
  const apiFormNodeMove = useApiFormNodeMove()
  const apiListNodeTemplate = useApiListNodeTemplate()

  const title = useMemo(() => apiFormNodeTemplate.form.name, [apiFormNodeTemplate.form])

  const handleMatch = async () => await apiFormNodeTemplate.get(nodeID)

  const handleSubmit = async data => {
    if (data.parentID === -1) {
      data.parentID = null
    }

    await apiFormNodeMove.put(data.nodeID, data)
    const nodes = await apiListNodeTemplate.get(`ancestors/${data.nodeID}`)
    const path = buildTemplatePath(nodes, data.nodeID)
    history.replace(path)
  }

  const HeaderMenu = () => <TemplateMenu place="header" url={parentURL} node={apiFormNodeTemplate.form} />

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconMove} text="move" onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <FormSimple onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="nodeID" value={apiFormNodeTemplate.form.id} required />
            <FormSimpleCategorySelectFilter name="parentID" label="category" rootName="TEMPLATE" useApiListCategory={useApiListNodeTemplateCategory} required />
            <FormSimpleSubmitEdit text="move template" backURL={parentURL} />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
